export default __webpack_public_path__ + "static/media/foldArrow.7fa7fa71.svg";